import React, { SyntheticEvent, useContext } from "react";
import { Box, Paper, Tab, Tabs } from "@mui/material";
import "./NavBar.module.scss";
import Logo from "../Logo/Logo";

import { DashboardNavBarMenuItem } from "../../types";
import { NavBarContext } from "../../contexts";

type NavBarProps = {
    menuItems: DashboardNavBarMenuItem[];
    active: string | boolean;
    handleChange?: (e: SyntheticEvent, value: string) => void;
};

export default function NavBar({
    menuItems,
    active,
    handleChange,
}: NavBarProps) {
    const { ...navBarParams } = useContext(NavBarContext);

    return (
        <Box
            className="nav-bar-root"
            sx={{
                position: "sticky",
                top: 0,
                left: 0,
                display: navBarParams.notDisplay ? "none" : "",

                "@media (max-width:1024px)": {
                    position: "unset",
                    bottom: "0",
                },
            }}
        >
            <Paper
                sx={{
                    display: "flex",
                    height: "100vh",
                    boxShadow: "0px 4px 30px 0px #E3E6E8",
                    background: "#FFF",
                    flexDirection: "column",

                    "@media (max-width:1024px)": {
                        width: "100%",
                        position: "fixed",
                        height: "4.5rem",
                        bottom: "0",
                        justifyContent: "center",
                    },
                }}
            >
                <Box
                    display={"inline-flex"}
                    sx={{
                        alignItems: "center",
                        gap: "8px",
                        height: "64px",
                        cursor: "pointer",
                        marginLeft: "6.66%",
                        marginTop: "4vh",

                        "@media (max-width:1024px)": {
                            display: "none",
                        },
                    }}
                >
                    <Logo customwidth="63" gap="0.5rem" />
                </Box>
                <Tabs
                    orientation="vertical"
                    value={active}
                    onChange={handleChange}
                    TabIndicatorProps={{
                        style: {
                            display: "none",
                            fontWeight: "600",
                        },
                    }}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",

                        flexShrink: 0,
                        marginLeft: "6.66%",
                        marginTop: "3rem",

                        "@media (max-width:1024px)": {
                            width: "100%",
                            margin: "0",
                        },

                        ".MuiTabs-flexContainer": {
                            alignItems: "flex-start",
                            gap: "1rem",

                            "@media (max-width:1024px)": {
                                flexDirection: "row",
                                justifyContent: "space-evenly",
                                padding: "0.5rem",
                                gap: "unset",
                            },
                        },
                    }}
                >
                    {menuItems.map((menuItem: DashboardNavBarMenuItem) => {
                        const { onClick, menuLabel, icon, activeIcon, id } =
                            menuItem;
                        const isActiveTab = active === id;
                        return (
                            <Tab
                                label={menuLabel}
                                key={id}
                                value={id}
                                iconPosition="start"
                                icon={
                                    <img
                                        src={isActiveTab ? activeIcon : icon}
                                        alt={menuLabel}
                                        width={"24"}
                                        height="24"
                                    />
                                }
                                onClick={() => {
                                    if (onClick) {
                                        onClick();
                                    }
                                }}
                                sx={{
                                    "&.MuiTab-labelIcon": {
                                        color: isActiveTab
                                            ? "#005499"
                                            : "#555A5D",
                                        textAlign: "center",
                                        fontFamily: "Roboto",
                                        fontSize: "16px",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "normal",
                                        textTransform: "none",
                                        padding: 0,
                                        minWidth: 0,
                                        gap: "0.5rem",
                                        minHeight: 0,

                                        "@media (max-width:1024px)": {
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "0.25rem",
                                            fontSize: "0.8rem",
                                            width: "27%",

                                            img: {
                                                margin: "auto",
                                            },
                                        },
                                    },
                                }}
                            />
                        );
                    })}
                </Tabs>
            </Paper>
        </Box>
    );
}
